export default __webpack_public_path__ + "static/m1-b2bcd4f1a0aba31c6d64fd75449541f8.jpg";